import { useState } from "react";
import { useCollection } from "@/hooks/useCollection";
import { PageHeader, NativeSelect } from "@/components/crm/common";
import { ExpenseTable } from "@/components/crm/Expenses";

export function ExpensePage({ kind, num, title, subtitle }) {
  const { items: projects } = useCollection("projects");
  const [pid, setPid] = useState("");
  return (
    <>
      <PageHeader num={num} title={title} subtitle={subtitle}>
        <NativeSelect testid="expense-project-select" className="min-w-[220px]" value={pid} onChange={setPid} placeholder="All projects" options={projects.map((p) => ({ value: p.id, label: p.name }))} />
      </PageHeader>
      <ExpenseTable key={pid || "all"} kind={kind} projectId={pid || null} projects={projects} />
    </>
  );
}

export default function VendorExpenses() {
  return <ExpensePage kind="vendor" num="15" title="Vendor Expenses" subtitle="Bills, amounts, approvals and payments — every expense is linked to a project." />;
}
